export default {
    title: 'Você está na nova <br /> versão para celular!',
    content: 'Explore a versão atualizada do <br /> aplicativo e caso queira voltar pra <br /> versão anterior acesse ',
    editProfile: 'Editar Perfil',
    buttonText: 'Conhecer a nova versão!'
};